import React from 'react';
import EvidencePanel from './EvidencePanel';
import './EvidenceDrawer.css';

const EvidenceDrawer = ({
  isOpen,
  onClose,
  lead,
  apiEndpointPrefix = '/lead-pipeline',
  initialTab = 'fields',
  highlightField = null,
  onOpenLockModal,
  onLeadUpdated,
  canEdit = true,
}) => {
  if (!isOpen) return null;

  return (
    <div className="evidence-drawer-backdrop" onClick={onClose}>
      <div className="evidence-drawer" onClick={(e) => e.stopPropagation()}>
        {/* Drawer Header */}
        <div className="evidence-drawer-header">
          <div className="evidence-drawer-lead-info">
            <span className="evidence-drawer-subtitle">
              <i className="fas fa-layer-group" /> Field Provenance & Integrity
            </span>
            <h2 className="evidence-drawer-title">
              {lead?.name || lead?.full_name || 'Lead Evidence Ledger'}
            </h2>
            <div className="evidence-lead-meta">
              {lead?.company_name || lead?.company ? (
                <span className="evidence-meta-pill">
                  <i className="fas fa-building" /> {lead.company_name || lead.company}
                </span>
              ) : null}
              {lead?.job_title || lead?.jobTitle ? (
                <span className="evidence-meta-pill">
                  <i className="fas fa-user-tie" /> {lead.job_title || lead.jobTitle}
                </span>
              ) : null}
            </div>
          </div>
          <div className="evidence-drawer-header-actions">
            <button type="button" className="evidence-close-btn" onClick={onClose}>
              <i className="fas fa-times" />
            </button>
          </div>
        </div>

        {/* Embedded Panel */}
        <EvidencePanel
          lead={lead}
          apiEndpointPrefix={apiEndpointPrefix}
          initialTab={initialTab}
          highlightField={highlightField}
          onOpenLockModal={onOpenLockModal}
          onLeadUpdated={onLeadUpdated}
          canEdit={canEdit}
        />
      </div>
    </div>
  );
};

export default EvidenceDrawer;
